import(/* webpackMode: "eager" */ "C:\\Users\\Andres\\Desktop\\GenWebsite\\frontend\\src\\app\\cliente\\page.js");
